// Ecommerce display range: the shelf-family maths, plus the metrics that live outside the
// answer variant. Banner and subscribe figures are stored in their own answer blocks, so the
// range walk resolves them through this hook instead of reading answer.aN directly.

import { calcDisplayRange as calcShelfDisplayRange } from '@aytm/app/stats/page/question-views/sh/lib/display-range'

const BANNER_VIEW_MODES = [
  'bannerImpressions',
  'bannerClicks',
  'bannerCtr',
  'bannerFunnelPopup',
  'bannerFunnelCart',
  'bannerAvgViewToClick'
]

const SUBSCRIBE_VIEW_MODES = [
  'subscribeRate',
  'subscribeSpend',
  'considerationRate',
  'churnRate',
  'reversalRate',
  'frequency'
]

const SUBSCRIBE_RATE_MODES = ['subscribeRate', 'considerationRate', 'churnRate', 'reversalRate']

const bannerValueOf = (viewMode, answer, answerKey) => {
  const banner = answer?.banners?.[answerKey] || {}
  const funnel = answer?.banners?.funnel?.[answerKey] || {}

  switch (viewMode) {
    case 'bannerImpressions':
      return banner.impressions || 0
    case 'bannerClicks':
      return banner.clicks || 0
    case 'bannerCtr':
      return (banner.ctr || 0) * 100
    case 'bannerFunnelPopup':
      return (funnel.clickToPopupRate || 0) * 100
    case 'bannerFunnelCart':
      return (funnel.clickToCartRate || 0) * 100
    case 'bannerAvgViewToClick':
      return banner.avgViewToClick || 0
    default:
      return 0
  }
}

const subscribeValueOf = (viewMode, answer, answerKey) => {
  const subscribe = answer?.subscribe?.[answerKey] || {}

  if (SUBSCRIBE_RATE_MODES.includes(viewMode)) return (subscribe[viewMode] || 0) * 100
  if ('subscribeSpend' === viewMode) return subscribe.subscribeSpend || 0
  if ('frequency' === viewMode) return subscribe.frequency?.[0]?.pct || 0

  return 0
}

// an unhandled view mode falls through to the answer variant itself
const resolveValue = (viewMode, answer, answerKey) => {
  if (BANNER_VIEW_MODES.includes(viewMode)) return bannerValueOf(viewMode, answer, answerKey)
  if (SUBSCRIBE_VIEW_MODES.includes(viewMode)) return subscribeValueOf(viewMode, answer, answerKey)
}

export const calcDisplayRange = (params = {}) => calcShelfDisplayRange({ ...params, resolveValue })
